import * as React from "react";
import { CustomModal } from "@/components/ui/CustomModal";

type DiscardDraftModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => Promise<void> | void;
  disabled: boolean;
};

export function DiscardDraftModal({
  open,
  onOpenChange,
  onConfirm,
  disabled,
}: DiscardDraftModalProps) {
  return (
    <CustomModal open={open} onOpenChange={onOpenChange} maxWidth="max-w-md">
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-slate-800">
          Discard draft changes?
        </h3>
        <p className="text-sm text-slate-600">
          This will replace the draft with the last published version. You cannot undo this action.
        </p>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            className="rounded-md border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="rounded-md bg-amber-600 px-3 py-1.5 text-sm font-semibold text-white hover:bg-amber-500 disabled:opacity-60"
            onClick={() => onConfirm()}
            disabled={disabled}
          >
            Discard draft
          </button>
        </div>
      </div>
    </CustomModal>
  );
}
